import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AbstractPage } from '@app/abstract/abstract-page.directive';
import { ClientService } from '@app/services/client.service';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular';
import { ModalController } from '@ionic/angular/lazy';
import { IonicModule } from '@ionic/angular/lazy';
import { TranslateModule } from '@ngx-translate/core';
import { UiMobileModule } from '@web/ui-mobile';
import { RateApp } from 'capacitor-rate-app';

@Component({
    selector: 'web-rating-modal',
    standalone: true,
    imports: [IonicModule, UiMobileModule, ReactiveFormsModule, TranslateModule],
    templateUrl: './rating-modal.component.html',
    styleUrls: ['./rating-modal.component.scss'],
})
export class RatingModalComponent extends AbstractPage implements OnInit {
    public override tag = 'RatingModalComponent';
    protected readonly platform = inject(Platform);
    protected readonly modalCtrl = inject(ModalController);
    protected readonly clientService = inject(ClientService);

    deviceType?: 'android' | 'ios';

    ngOnInit(): void {
        if (this.platform.is('android') || Capacitor.getPlatform() === 'android') {
            this.deviceType = 'android';
        } else if (this.platform.is('ios') || Capacitor.getPlatform() === 'ios') {
            this.deviceType = 'ios';
        }
    }

    close() {
        this.clientService.updateReview(false, true).subscribe();
        return this.modalCtrl.dismiss(null, 'close');
    }

    public async rate(): Promise<void> {
        this.clientService.updateReview(true, true).subscribe();

        try {
            await RateApp.requestReview();
        } catch (error) {
            console.error(`${this.tag} RateApp.requestReview failed`, error);
        }

        await this.modalCtrl.dismiss(null, 'rate');
    }
}
